export const formatXml = (xml: string): string => {
  const PADDING = ' '.repeat(2) // set desired indent size here
  const reg = /(>)(<)(\/*)/g
  let pad = 0
  return xml
    .replace(reg, '$1\r\n$2$3')
    .split('\r\n')
    .map((node) => {
      let indent = 0
      if (node.match(/.+<\/\w[^>]*>$/)) {
        indent = 0
      } else if (node.match(/^<\/\w/)) {
        if (pad !== 0) {
          pad -= 1
        }
      } else if (node.match(/^<\w([^>]*[^\/])?>.*$/)) {
        indent = 1
      } else {
        indent = 0
      }

      const padding = PADDING.repeat(pad)
      pad += indent
      return padding + node
    })
    .join('\r\n')
}
